import request from '@/utils/request'

// 商品供货商表 2021-04-29 09:30:13

let DistributorApi = {

    /*列表*/
    getList(data, errorback) {
        return request._get('/shop/distributor.distributor/index', data, errorback);
    },

    /*添加*/
    add(data, errorback) {
        return request._post('/shop/distributor.distributor/add', data, errorback);
    },

    /*删除*/
    del(data, errorback) {
        return request._post('/shop/distributor.distributor/del', data, errorback);
    },

    /*编辑*/
    edit(data, errorback) {
        return request._post('/shop/distributor.distributor/edit', data, errorback);
    },
}

export default DistributorApi;



// WEBPACK FOOTER //
// ./src/api/distributor.js